import React from 'react';
import { Cards } from "./Cards";
import { CardsContextProvider } from "./CardsContext";

export function CardsIndex({ basePath, type, isLegacy }) {
  return (
    <CardsContextProvider basePath={basePath} type={type} isLegacy={isLegacy}>
      <Cards />
    </CardsContextProvider>
  )
}
